import QuestionViewModal from "modules/question-bank/questionViewmodal";
import React, { useEffect, useState, useRef } from "react";
import { apiPaths, getAdminData, getData, postInstituteAppData, deleteInstituteAppData, postData, getInstutueApp } from "../platform-components/api-integration-util";
import Grid from "../platform-components/grid/Grid";
import { getUserDetails } from "../platform-components/utils/shared-data.service";
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, IconButton, InputAdornment, MenuItem, Modal, Select, Tab, Tabs, TextField, Typography } from "@mui/material";
import moment from 'moment';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { Toaster } from "../platform-components/Toaster";
import { toast } from "react-toastify";
import { checkPermission } from "../platform-components/utils/configuration";
import { filterBySubjectScope } from "../platform-components/utils/subject-scope";


const PAGE_SIZE = 20;

const Qb = () => {
  const [loading, setLoading] = useState(true);
  const [QBCount, setQBCount] = useState(0);
  const [selectedQuestionId, setSelectedQuestionId] = useState(null);
  const [questionDataList, setQuestionDataList] = useState([]);
  const [questionData, setQuestionData] = useState({});
  const [selectedQuestionIndex, setSelectedQuestionIndex] = useState(-1);
  const [selectedQuestionEditable, setSelectedQuestionEditable] = useState(null);
  const [value, setValue] = React.useState('Normal-Tests');
  const [openAddQnModal, setOpenAddQnModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [deletedQnId, setDeletedQnId] = useState();
  const [addedQuestionId, setAddedQuestionId] = useState();
  const [addQuestionError, setAddQuestionError] = useState("");
  const [libraryTestId, setLibraryTestId] = useState();
  const [selectedTestInfo, setSelectedTestInfo] = useState(null);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [includeExplanation, setIncludeExplanation] = useState(false);
  const [includeAnswer, setIncludeAnswer] = useState(false);
  const [includeQuestion, setIncludeQuestion] = useState(false);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [pageData, setPageData] = useState([]);

  // Filter state
  const [searchText, setSearchText] = useState('');
  const [filterTestType, setFilterTestType] = useState('');
  const searchTimerRef = useRef(null);

  const getTestModeFilter = (tab) => {
    return tab === 'Custom-Tests' ? 'CUSTOM-TEST' : 'NORMAL';
  };

  // The actual search value sent to API (updated after debounce)
  const [debouncedSearch, setDebouncedSearch] = useState('');

  // Fetch data when tab, page, or filters change
  useEffect(() => {
    let cancelled = false;
    const doFetch = async () => {
      setLoading(true);
      try {
        const params = {
          page: currentPage,
          size: PAGE_SIZE,
          testModeFilter: getTestModeFilter(value),
        };
        if (debouncedSearch && debouncedSearch.trim()) params.search = debouncedSearch.trim();
        if (filterTestType && filterTestType.trim()) params.testType = filterTestType.trim();

        const queryString = Object.entries(params)
          .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
          .join('&');

        const response = await getAdminData(`${apiPaths.getLibraryTestsPaginated}?${queryString}`);
        if (cancelled) return;
        const result = response.result;
        setPageData(
          filterBySubjectScope(result.content || [], (t) => t.subjectId ?? t.subject_id)
        );
        setCurrentPage(result.page);
        setTotalElements(result.totalElements);
        setTotalPages(result.totalPages);
      } catch (error) {
        if (cancelled) return;
        console.error("Error fetching Test data:", error);
        setPageData([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    doFetch();
    return () => { cancelled = true; };
  }, [currentPage, value, debouncedSearch, filterTestType]);

  // Debounced search — updates debouncedSearch after 400ms, which triggers the useEffect
  const handleSearchChange = (e) => {
    const text = e.target.value;
    setSearchText(text);
    if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
    searchTimerRef.current = setTimeout(() => {
      setCurrentPage(0);
      setDebouncedSearch(text);
    }, 400);
  };

  const handleTestTypeChange = (e) => {
    setFilterTestType(e.target.value);
    setCurrentPage(0);
  };

  const handleChange = (event, newValue) => {
    // Clear any pending search debounce timer to prevent stale search leaking into new tab
    if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
    setValue(newValue);
    setCurrentPage(0);
    setSearchText('');
    setDebouncedSearch('');
    setFilterTestType('');
    // Clear selected test context when switching tabs
    setSelectedTestInfo(null);
    setQuestionDataList([]);
    setLibraryTestId(undefined);
    setQBCount(0);
  };

  const handleQuestionClick = (rowData) => {
    const testId = rowData.libraryTestId;
    setLibraryTestId(testId);
    setSelectedTestInfo(rowData);
    getAdminData(`${apiPaths.getQuestionIdsByTest}?libraryTestId=${testId}`).then((response) => {
      if (response.result) {
        setQuestionDataList([]);
        setQuestionDataList(response.result);
        setQBCount(response.result.length);
      }
    });
  };

  const clearSelectedTest = () => {
    setSelectedTestInfo(null);
    setLibraryTestId(undefined);
    setQuestionDataList([]);
    setQBCount(0);
  };

  const handleQuestionIdClick = (questionId) => {
    const clickedIndex = questionDataList.indexOf(questionId);
    setSelectedQuestionIndex(clickedIndex);
    setSelectedQuestionId(questionId);
    getData(apiPaths.questionbyid + `?id=${questionId}`).then((response) => {
      if (response.result) {
        setQuestionData(response.result);
      }
    });
  };

  const link = (params) => {
    return (
      <div className="text-link" onClick={() => handleQuestionClick(params.data)}>
        {params?.value}
      </div>
    );
  };

  const qIDlink = (params) => {
    return (
      <div className="text-link" onClick={() => handleQuestionIdClick(params.value)}>
        {params?.value}
      </div>
    );
  };
  const button = (params) => {
    return (
      <div>
        <IconButton className="delete-icon" style={{ padding: "0px", marginLeft: "10px" }} aria-label="delete" onClick={() => { handleClickOpen(params) }}>
          <DeleteIcon />
        </IconButton>
      </div>
    );
  };
  const questionColumnDefs = [
    { headerName: "Index", valueGetter: "node.rowIndex + 1" },
    { headerName: "Question IDs", field: "value", valueGetter: "data", cellRendererFramework: qIDlink, filter: true },
    { headerName: "Actions", field: "actions", cellRendererFramework: button, },
  ];

  const columnDefs = [
    {
      headerName: "Test Name",
      field: "testName",
      cellRendererFramework: link,
    },
    {
      headerName: "Description",
      field: "description",
    },
    {
      headerName: "Question Count",
      field: "questionCount",
    },
    {
      headerName: "Locked",
      field: "locked"
    },
    {
      headerName: "Subject",
      field: "subject",
    },
    {
      headerName: "Test Mode",
      field: "testMode",
    },
    {
      headerName: "Test Type",
      field: "testType",
    },
    {
      headerName: "Test Time (mins)",
      field: "testTimeInMins",
    },
    {
      headerName: "Created By",
      field: "createdBy",
    },
    {
      headerName: "Created Date",
      field: "createdDate",
      valueFormatter: (createdDate) => {
        return createdDate ? moment(createdDate.value).format("DD-MM-YYYY hh:mm A") : '';
      },
    },
    {
      headerName: "Updated By",
      field: "updatedBy",
    },
    {
      headerName: "Updated Date",
      field: "updatedDate",
      valueFormatter: (updatedDate) => {
        return updatedDate ? moment(updatedDate.value).format("DD-MM-YYYY hh:mm A") : '';
      },
    },
  ];

  const gridOptions = {
    columnDefs,
    rowData: pageData,
  };

  const openAddQuestionModal = () => {
    setAddQuestionError("");
    setOpenAddQnModal(true);
  };

  const handleDownload = () => {
    setShowDownloadModal(true);
  };

  const handleRefreshCache = () => {
    if (!libraryTestId) return;
    if (!window.confirm(`Refresh CloudFront + Redis cache for test ${libraryTestId}? This will force students to get the latest question data.`)) return;
    postInstituteAppData(apiPaths.refreshTestCache, {
      data: {},
      params: { libraryTestId },
      headers: {
        tenantId: getUserDetails().tenantId,
        userEmail: getUserDetails().email,
      },
    })
      .then((response) => {
        if (response && response.responseCode === 200) {
          toast.success(response.msg || "Cache refresh scheduled");
        } else {
          toast.error((response && response.msg) || "Failed to refresh cache");
        }
      })
      .catch((err) => toast.error(typeof err === "string" ? err : "Failed to refresh cache"));
  };

  const handleDownloadClose = () => {
    setShowDownloadModal(false);
  };

  const handleDownloadTest = () => {
    getInstutueApp(`${apiPaths.downloadTest}?libraryTestId=${libraryTestId}&includeExplanation=${includeExplanation}&includeQuestion=${includeQuestion}&includeAnswer=${includeAnswer}`, null, {
      tenantId: getUserDetails().tenantId,
      userEmail: getUserDetails().email
    }, 'blob')
      .then(async (res) => {
        const blob = new Blob([res.data], { type: res.headers['content-type'] });
        let fileName = "downloaded-file";
        const disposition = res.headers['content-disposition'];
        if (disposition && disposition.includes("filename=")) {
          const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (match != null && match[1]) {
            fileName = match[1].replace(/['"]/g, '');
          }
        }

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => console.log(err));
  };

  const handleCloseAddQuestionModal = () => {
    setAddQuestionError("");
    setOpenAddQnModal(false);
  };
  const handleClickOpen = (data) => {
    setDeletedQnId(data.data);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleDeleteQuestion = async () => {
    const response = await deleteInstituteAppData(apiPaths.deleteQuestionFromTest, {
      data: [],
      params: {
        questionId: deletedQnId,
        libraryTestId: libraryTestId
      },
      headers: {
        tenantId: getUserDetails().tenantId,
        userEmail: getUserDetails().email,
      },
    });
    handleClose();
    if (response.result == true) {
      Toaster(toast.TYPE.SUCCESS, "Question deleted Successfully");
      refreshTopicQuestions();
    } else {
      Toaster(toast.TYPE.ERROR, "Error in deleting question");
    }
  };
  const AddQuestionClick = async () => {
    // postInstituteAppData rejects with the API's msg string on any non-2xx, so the 400 the backend
    // raises for a question that has not cleared review only reaches the user if we catch it here.
    try {
      const response = await postInstituteAppData(apiPaths.addQuestionToTest, {
        data: [],
        params: {
          questionId: addedQuestionId,
          libraryTestId: libraryTestId
        },
        headers: {
          tenantId: getUserDetails().tenantId,
          userEmail: getUserDetails().email,
        },
      });
      handleCloseAddQuestionModal();
      if (response.result == true) {
        Toaster(toast.TYPE.SUCCESS, "Question Id Added Successfully");
        refreshTopicQuestions();
      } else {
        Toaster(toast.TYPE.ERROR, response.msg || "Error in adding question Id");
      }
    } catch (err) {
      // Keep the Add dialog open so the id stays in the field and can be corrected in place.
      setAddQuestionError(typeof err === "string" ? err : "Error in adding question Id");
    }
  };
  const refreshTopicQuestions = () => {
    if (selectedTestInfo) handleQuestionClick(selectedTestInfo);
  };

  return (
    <div>
      <h2>Tests</h2>
      <Box sx={{ width: '100%', typography: 'body1', marginBottom: "20px" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="wrapped label tabs example"
        >
          {checkPermission('Test', 'Normal Tests') && <Tab value="Normal-Tests" label="Normal Tests"></Tab>}
          {checkPermission('Test', 'Custom Tests') && <Tab value="Custom-Tests" label="Custom Tests"></Tab>}
        </Tabs>
      </Box>

      {/* Server-side filter controls */}
      <Box sx={{ display: 'flex', gap: 2, marginBottom: '16px', alignItems: 'center' }}>
        <TextField
          size="small"
          placeholder="Search by test name or created by..."
          value={searchText}
          onChange={handleSearchChange}
          sx={{ width: 350 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
        <Select
          size="small"
          value={filterTestType}
          onChange={handleTestTypeChange}
          displayEmpty
          sx={{ minWidth: 180 }}
        >
          <MenuItem value="">All Test Types</MenuItem>
          <MenuItem value="GRAND-TEST">Grand Test</MenuItem>
          <MenuItem value="MOCK-TEST">Mock Test</MenuItem>
          <MenuItem value="LIVE">Live</MenuItem>
          <MenuItem value="PREVIOUS-TESTS">Previous Tests</MenuItem>
          <MenuItem value="SUBJECT">Subject</MenuItem>
        </Select>
        <Typography variant="body2" sx={{ marginLeft: 'auto', color: '#666' }}>
          Showing {pageData.length} of {totalElements} tests
          {totalPages > 1 && ` (Page ${currentPage + 1} of ${totalPages})`}
        </Typography>
      </Box>

      {loading && <p>Loading...</p>}
      {!loading && (
        <Grid
          gridOptions={{
            ...gridOptions,
            pagination: false,
            domLayout: 'autoHeight',
          }}
          parent="qb"
        />
      )}

      {/* Server-side pagination controls. `.ag-grid-main` is float:left, so this row has to clear
          the float or it is laid out beside the grid instead of below it. */}
      {!loading && totalPages > 1 && (
        <Box sx={{ clear: 'both', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, marginTop: '16px', marginBottom: '16px' }}>
          <Button
            variant="outlined"
            size="small"
            disabled={currentPage === 0}
            onClick={() => setCurrentPage(0)}
          >
            First
          </Button>
          <Button
            variant="outlined"
            size="small"
            disabled={currentPage === 0}
            onClick={() => setCurrentPage(prev => prev - 1)}
          >
            Previous
          </Button>
          <Typography variant="body2">
            Page {currentPage + 1} of {totalPages}
          </Typography>
          <Button
            variant="outlined"
            size="small"
            disabled={currentPage >= totalPages - 1}
            onClick={() => setCurrentPage(prev => prev + 1)}
          >
            Next
          </Button>
          <Button
            variant="outlined"
            size="small"
            disabled={currentPage >= totalPages - 1}
            onClick={() => setCurrentPage(totalPages - 1)}
          >
            Last
          </Button>
        </Box>
      )}

      {selectedQuestionId && (
        <QuestionViewModal
          open={true}
          handleClose={() => {
            setSelectedQuestionId(null);
            setSelectedQuestionIndex(-1);
            setQuestionData({});
          }}
          selectedQuestionEditable={selectedQuestionEditable}
          isEditEnabled={true}
          prevQuestion={
            selectedQuestionIndex > 0
              ? questionDataList[selectedQuestionIndex - 1]
              : null
          }
          nxtQuestion={
            selectedQuestionIndex < questionDataList.length - 1
              ? questionDataList[selectedQuestionIndex + 1]
              : null
          }
          questionData={questionData}
          QBCount={QBCount}
          selectedQuestion={selectedQuestionId}
          // Deletes the QUESTION, not just its mapping into this test - which is what the row's
          // bin icon does. The confirm dialog names the difference.
          onQuestionDeleted={() => {
            setSelectedQuestionId(null);
            setSelectedQuestionIndex(-1);
            setQuestionData({});
            refreshTopicQuestions();
          }}
          setId={(e) => {
            setSelectedQuestionId(e);
            setSelectedQuestionIndex(questionDataList.indexOf(e));
            getData(apiPaths.questionbyid + `?id=${e}`).then((response) => {
              if (response.result) {
                setQuestionData(response.result);
              }
            });
          }}
        />
      )}

      {questionDataList.length > 0 && selectedTestInfo && (
        <Box sx={{ clear: 'both' }}>
          <Box sx={{
            mt: 3, mb: 2, p: 2,
            backgroundColor: '#f0f4ff',
            border: '1px solid #c5cae9',
            borderRadius: '6px',
          }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 600, color: '#1a237e' }}>
                  {selectedTestInfo.testName}
                </Typography>
                <Box sx={{ display: 'flex', gap: 3, mt: 0.5, flexWrap: 'wrap', color: '#555', fontSize: '14px' }}>
                  {selectedTestInfo.testMode && <span>Mode: <strong>{selectedTestInfo.testMode}</strong></span>}
                  {selectedTestInfo.testType && <span>Type: <strong>{selectedTestInfo.testType}</strong></span>}
                  {selectedTestInfo.subject && <span>Subject: <strong>{selectedTestInfo.subject}</strong></span>}
                  <span>Questions: <strong>{QBCount}</strong></span>
                </Box>
              </Box>
              <IconButton size="small" onClick={clearSelectedTest} title="Close">
                <CloseIcon />
              </IconButton>
            </Box>
            <Box sx={{ mt: 1.5, display: 'flex', gap: 1 }}>
              <Button variant="contained" size="small" onClick={openAddQuestionModal}>Add Question Id</Button>
              {/* "Create Question" (create + auto-map via ?addToTest=) is hidden: a new question is
                  created in SAVED status, and only APPROVED questions can be mapped into a test.
                  The shortcut could only ever create the question and fail the map. Create it from
                  the Question Bank, get it approved, then use "Add Question Id" here. */}
              <Button variant="contained" size="small" onClick={handleDownload}>Download</Button>
              <Button variant="outlined" size="small" color="warning" onClick={handleRefreshCache}>Refresh Cache</Button>
            </Box>
          </Box>
          <Grid
            gridOptions={{
              columnDefs: questionColumnDefs,
              rowData: questionDataList,
              pagination: questionDataList.length > 10,
              paginationPageSize: 10,
            }}
            parent="questionData"
          />
        </Box>
      )}

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Make sure you remove every link to the question—in both the question bank and any tests—before you delete it. Question Id: <strong>{deletedQnId}</strong> ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleClose}>Close</Button>
          <Button variant="contained"
            onClick={handleDeleteQuestion} color="error" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openAddQnModal}
        onClose={handleCloseAddQuestionModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Add Question Id<CloseIcon className="close-icon" onClick={handleCloseAddQuestionModal} /></DialogTitle>
        <DialogContent style={{ paddingTop: "10px" }}>
          <DialogContentText id="alert-dialog-description">
            <div class="">
              <TextField
                id="outlined-basic"
                label="Question Id"
                placeholder="Question Id"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                size="small"
                value={addedQuestionId}
                style={{ width: "100%" }}
                onChange={(item) => {
                  setAddedQuestionId(item.target.value);
                  if (addQuestionError) setAddQuestionError("");
                }}
              />
              {addQuestionError ? (
                <Typography color="error" style={{ marginTop: "12px", fontSize: "14px" }}>
                  {addQuestionError}
                </Typography>
              ) : null}
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={AddQuestionClick} autoFocus>Add</Button>
        </DialogActions>
      </Dialog>
      <Modal open={showDownloadModal} onClose={handleDownloadClose} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Box sx={{ p: 2, width: 400, backgroundColor: '#fff', borderRadius: '4px', boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.15)' }}>
          <Typography variant="h5" sx={{ mb: 2 }}>
            Download Tests
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={includeExplanation}
                onChange={(e) => setIncludeExplanation(e.target.checked)}
              />
            }
            label="Include Explanation"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={includeAnswer}
                onChange={(e) => setIncludeAnswer(e.target.checked)}
              />
            }
            label="Include Answer"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={includeQuestion}
                onChange={(e) => setIncludeQuestion(e.target.checked)}
              />
            }
            label="Include Question"
          />
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
            <Button variant="contained" onClick={handleDownloadTest}>
              Download
            </Button>
            <Button variant="outlined" sx={{ ml: 2 }} onClick={handleDownloadClose}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );

};

export default Qb;
